import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { GraphQLClient } from 'data/graphql/network'

import { getConfig, getApiEndpoint } from 'data/config/selectors'
import { selectors as AuthSelectors } from 'data/auth'
import { actions as UIActions, selectors as UISelectors } from 'data/ui'
import { setGraphQLClient } from 'data/dependencies'

class GraphQLProvider extends Component {
  static childContextTypes = {
    graphQLClient: PropTypes.instanceOf(GraphQLClient).isRequired,
  }

  constructor(props, context) {
    super(props, context)
    const { config, apiEndpoint, apiToken, setConnectionStatus } = props

    this.graphQLClient = new GraphQLClient({
      config,
      getApiEndpoint: () => apiEndpoint,
      getApiToken: () => apiToken,
    })

    if (apiToken) {
      this.unsubscribes = [
        this.graphQLClient.subscriptionClient.onConnected(() => {
          setConnectionStatus(UISelectors.CONNECTION_STATUSES_TYPE.CONNECTED)
        }),
        this.graphQLClient.subscriptionClient.onReconnected(() => {
          setConnectionStatus(UISelectors.CONNECTION_STATUSES_TYPE.CONNECTED)
        }),
        this.graphQLClient.subscriptionClient.onDisconnected(() => {
          this.graphQLClient.subscriptionClient.unsubscribeAll() // Subscriptions hoc will reconnect
          setConnectionStatus(UISelectors.CONNECTION_STATUSES_TYPE.DISCONNECTED)
        }),
      ]
    }
  }

  componentDidMount() {
    this.props.setGraphQLClient(this.graphQLClient)
  }

  componentWillUnmount() {
    if (this.unsubscribes) {
      this.unsubscribes.forEach(unsubscribe => unsubscribe())
    }
    this.props.setGraphQLClient(null)
  }

  render() {
    return this.props.children
  }

  getChildContext() {
    return {
      graphQLClient: this.graphQLClient,
    }
  }
}

const mapStateToProps = state => ({
  config: getConfig(state),
  apiEndpoint: getApiEndpoint(state),
  apiToken: AuthSelectors.getApiToken(state),
})

const mapDispatchToProps = {
  setConnectionStatus: status => {
    return UIActions.setConnectionStatus({ service: 'graphql', status })
  },
  setGraphQLClient,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GraphQLProvider)

export function withGraphQLClient(OriginalComponent) {
  return class WithGraphqlClient extends Component {
    static displayName = `WithGraphQLClient(${OriginalComponent.displayName ||
      'Unknown'})`

    static contextTypes = {
      graphQLClient: PropTypes.instanceOf(GraphQLClient).isRequired,
    }

    render() {
      return (
        <OriginalComponent
          {...this.props}
          graphQLClient={this.context.graphQLClient}
        />
      )
    }
  }
}
